module.exports = __webpack_public_path__ + "static/media/Lock.ff05c92a.svg";